export default {
  props: {
    courseData: {
      required: true,
      type: Object,
      default() {
        return {
          ideology_name: ''
        };
      }
    }
  },
  data() {
    return {
      backgroundColorList: ['#F3E1D7', '#D6D6E4', '#E1ECE0', '#F9EAD7']
    };
  },
  computed: {
    coverIndex() {
      let id = String(this.courseData.id);
      let length = id.length;
      let lastId = id.charAt(length - 1);
      return Math.floor(lastId * 0.4);
    },
    ideologyNameList() {
      if (this.courseData.ideology_name) {
        return this.courseData.ideology_name.split(',');
      } else {
        return [];
      }
    }
  },
  methods: {
    handleLink() {
      localStorage.setItem('currentUrl', document.URL);
      window.location.href = `/caseDetail.html?siteId=${this.courseData.siteId}`;
    }
  }
};